import { mentorJobsConstants } from "../../_constants";

const initialState = {};

//applied jobs reducer
export const get_applied_jobs_list_mentor_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorJobsConstants.GET_MENTOR_APPLIED_JOBS_LIST_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorJobsConstants.GET_MENTOR_APPLIED_JOBS_LIST_ACTION_SUCCESS:
      return {
        type: "alert-success",
        appliedJobsListData: action.payload,
      };
    case mentorJobsConstants.GET_MENTOR_APPLIED_JOBS_LIST_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//applied job details reducer
export const get_applied_job_details_mentor_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case mentorJobsConstants.GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case mentorJobsConstants.GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        appliedJobDetailsData: action.payload,
      };
    case mentorJobsConstants.GET_MENTOR_APPLIED_JOB_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

